// extracted by mini-css-extract-plugin
module.exports = {"stock":"stock-2zqqbAJM"};